/*
* CARRITO METHODS
*/

console.log("Carrito script cargado...")

// Form Despacho - Evento Click Select Shipping Method Radio
function setFormDespacho() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-despacho-selector-item")) {
        console.log("button item", buttonDespachoOption)
        buttonDespachoOption.addEventListener("click", (ev) => {
            console.log("clicked")
            
            // reset remove active
            for (let buttonDespachoOption of document.querySelectorAll(".enova-despacho-selector-item")) {
                buttonDespachoOption.classList.remove('active')
            }
          
            if(document.querySelector("input[name=enova-despacho]:checked")) {
                if( document.querySelector("input[name=enova-despacho]:checked").value === 'recojo-tienda' ) {
                    document.querySelector("#enova-despacho-recojo-tienda").classList.add("active")
                    document.querySelector("#enova-despacho-shipping").classList.remove("active")
    
                    document.querySelector("#enova-despacho-recojo-tienda").classList.remove("disabled")
                    document.querySelector("#enova-despacho-shipping").classList.add("disabled")


                    /* 
                    * reset deliery
                    */
                    if( document.querySelector("#enova-despacho-delivery-select-fecha") ) {
                        document.querySelector("#enova-despacho-delivery-select-fecha").value = null
                    }

                    if( document.querySelector("input[name=enova-despacho-tipo]:first-child") ) {
                        document.querySelector("input[name=enova-despacho-tipo]:first-child").checked = true
                    }

                    // documento DNI
                    // document.querySelector("input[name=enova-billing-doc]:first-child").checked = true
                    // document.querySelector("input[name=enova-billing-doc]:first-child").click()

                    // if( document.querySelector("#enova-billing-doc-ruc") ) {
                    //     document.querySelector("#enova-billing-doc-ruc").value = ""
                    // }

                    // if ( document.querySelector("#enova-billing-doc-razonsocial") ) {
                    //     document.querySelector("#enova-billing-doc-razonsocial").value = ""
                    // }

                    // Lista stores build
                    getPickUpShopList(null)

                } else if ( document.querySelector("input[name=enova-despacho]:checked").value === 'delivery' ) {
                    document.querySelector("#enova-despacho-shipping").classList.add("active")
                    document.querySelector("#enova-despacho-recojo-tienda").classList.remove("active")
    
                    document.querySelector("#enova-despacho-shipping").classList.remove("disabled")
                    document.querySelector("#enova-despacho-recojo-tienda").classList.add("disabled")

                    /* 
                    * reset recojo en tienda
                    */
                    if( document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha") ) {
                        document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha").classList.remove("active")
                    }

                    if( document.querySelector("#enova-despacho-recojo-tienda-select-fecha") ) {
                        document.querySelector("#enova-despacho-recojo-tienda-select-fecha").value = null
                    }

                }

                // add class hover active
                document.querySelector("input[name=enova-despacho]:checked").parentElement.classList.add('active')

            }
    
        })
    }
    
}

setFormDespacho()

// Form Despacho - Evento Click Select Billing Doc
function setFormBillingDoc() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-billing-item")) {
        console.log("button item", buttonDespachoOption)
        buttonDespachoOption.addEventListener("click", (ev) => {
            console.log("clicked 2")
            
            // reset remove active
            for (let buttonDespachoOption of document.querySelectorAll(".enova-billing-item")) {
                buttonDespachoOption.classList.remove('active')
            }
          
            if(document.querySelector("input[name=enova-billing-doc]:checked")) {
                if( document.querySelector("input[name=enova-billing-doc]:checked").value === 'factura' ) {
                    document.querySelector("#enova-billing-doc").classList.add("active")
                    document.querySelector("#enova-billing-doc").classList.remove("disabled")

                    // validate is "recojo tienda" and "factura"
                    if (
                        document.querySelector("input[name=enova-despacho]:checked").value === 'recojo-tienda'
                    ) {
                        jQuery("#formulario--billing-address_checkbox").prop("checked", false)
                        jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "block")
                        jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox").css("display", "none")
                    }
        
                } else if ( document.querySelector("input[name=enova-billing-doc]:checked").value === 'boleta' ) {
                    document.querySelector("#enova-billing-doc").classList.remove("active")
                    document.querySelector("#enova-billing-doc").classList.add("disabled")

                    // reste factura
                    jQuery("#formulario--billing-address_checkbox").prop("checked", true)
                    jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "none")
                    jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox").css("display", "block")
                }

                // add class hover active
                document.querySelector("input[name=enova-billing-doc]:checked").parentElement.classList.add('active')

            }
    
        })
    }
    
}

setFormBillingDoc()


// Lista de tienda - evento click
function setStoresEventClick() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item")) {
        console.log("button item", buttonDespachoOption)
        buttonDespachoOption.addEventListener("click", (ev) => {
            console.log("clicked tienda")
            
            // reset remove active
            for (let buttonDespachoOption of document.querySelectorAll(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item")) {
                buttonDespachoOption.classList.remove('active')
            }
          
            if(document.querySelector("input[name=enova-despacho-recojo-tienda-item]:checked")) {
                if(document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha")) {
                    document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha").classList.add("active")
                }

                if( document.querySelector("#enova-despacho-recojo-tienda-select-fecha") ) {
                    document.querySelector("#enova-despacho-recojo-tienda-select-fecha").value = null
                }
                
                // add class hover active
                document.querySelector("input[name=enova-despacho-recojo-tienda-item]:checked").parentElement.classList.add('active')
            }
    
        })
    }
    
}
setStoresEventClick()

// Calculate shipping methods
function validateDeliveryForm(objectForm) {
    let validated = true
    for(let key in objectForm) {
        console.log("objectForm Value", objectForm[key])

        if(!objectForm || objectForm[key] === '' || objectForm[key] === null) {
            validated = false
        }
    }

    return validated
}

function calculateShippingMethods() {
    var checkerFormDespachoDelivery = setInterval(() => {
        let checkoutDeloiveryForm = {
            departamento: document.querySelector("#enova-carrito-block-despacho-shipping__departamento") ? document.querySelector("#enova-carrito-block-despacho-shipping__departamento").value : '',
            provincia: document.querySelector("#enova-carrito-block-despacho-shipping__provincia") ? document.querySelector("#enova-carrito-block-despacho-shipping__provincia").value : '',
            distrito: document.querySelector("#enova-carrito-block-despacho-shipping__distrito") ? document.querySelector("#enova-carrito-block-despacho-shipping__distrito").value : '',
            direccion: document.querySelector("#enova-despacho-direccion") ? document.querySelector("#enova-despacho-direccion").value : '',
            referencia: document.querySelector("#enova-despacho-referencia") ? document.querySelector("#enova-despacho-referencia").value : '',
        }   

        if( validateDeliveryForm(checkoutDeloiveryForm) ) {
       
            // show shippingm methods
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("active")
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("disabled")
        } else {
            // hide shipping methods
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("active")
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("disabled")
        }

    }, 1000)

}

//calculateShippingMethods()



function calculateShippingMethodByUbigeoSelected() {
    if( document.querySelector("#enova-carrito-block-despacho-shipping__distrito") ) {
        document.querySelector("#enova-carrito-block-despacho-shipping__distrito").addEventListener("change", () => {
            
             // Loading block - show
             despachoMethodShippingLoading('loading')

            if(
                document.querySelector("#enova-carrito-block-despacho-shipping__distrito") &&
                (
                    document.querySelector("#enova-carrito-block-despacho-shipping__distrito").value !== "0" &&
                    document.querySelector("#enova-carrito-block-despacho-shipping__distrito").value !== "Seleccione..."
                )
            ) {

                // EVALUAR SI ES UNA COMPRA DE PRODUCTO DIGITAL SOLAMENTE
                getResponseCartItems(true)
                    .then((carritoItemsListE) => {

                        if( !isCarritoProductTypeShipping(carritoItemsListE) ) {
                            // es compra digital 
                            // loading false
                            despachoMethodShippingLoading(null)
        
                            // remove shipping active default option
                            jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery").removeClass("active")

                            // Select despacho "servicio"
                            jQuery("#enova-despacho-enova-despacho-servicio-option").attr("checked", true)

                        } else {
                            /*
                            * Request lista de ubigeos
                            */
                            despachoMethodShippingLoading('loading')

                            // REQUEST API SERVICE 
                            let SelectedDepartamentoUBIGEO = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo") 
                            
                            var carrito_productos = carritoItemsListE.map((el_producto) => {

                                let selectedAttr_peso = el_producto.attributes.find((item_key) => item_key.key === "peso")
                                let selectedAttr_sku = el_producto.attributes.find((item_key) => item_key.key === "sku")

                                return ({
                                    "sku": selectedAttr_sku.value,
                                    "quantity": el_producto.quantity,
                                    "volumen_unit": null,
                                    "weight_unit": selectedAttr_peso.value ? parseFloat(selectedAttr_peso.value) : 0,
                                    "position": null
                                })
                            })
                            

                            // [{"quantity":1,"volumen_unit":null,"weight_unit":null,"position":null}]
                            let productCart = JSON.stringify(carrito_productos)
                            console.log("CARRITO FINAL carrito_productos", productCart)
                            
                            let urlBuilder = `?scope=district-calc-rates&ubigeo=${SelectedDepartamentoUBIGEO}&products=${productCart}`

                            console.log("CARRITO FINAL urlBuilder", urlBuilder)
                            if(SelectedDepartamentoUBIGEO) {
                                fetch(`${window.Shopify.routes.root}apps/apolo-ubigeo-calculation${ urlBuilder }`, {
                                    method: 'GET',
                                    headers:{
                                        'Content-Type': 'application/json'
                                    }
                                })
                                .then(res => res.json())
                                .then(response => {
                                    console.log('Success:', response)
                                    
                                    // Render Shippinh Methods
                                    SetRenderShippingMethodsListOption(response)

                                    // Loading block - disabled
                                    despachoMethodShippingLoading(null)
                                    
                                })
                                .catch(error => {
                                    console.error('Error:', error)
                                    despachoMethodShippingLoading(null)
                                })

                            } else {
                                alert("Debe seleccionar un Distrito Valido")
                            }
        
                        }

                    })
                    .catch((err) => {
                        console.log("err", err)
                        despachoMethodShippingLoading(null)
                    })
    
            } else {
                // Loading block - disabled
                despachoMethodShippingLoading(null)
            }
        })
    }
}

calculateShippingMethodByUbigeoSelected()


function despachoMethodShippingLoading(status) {
    if (status === 'loading') {
        document.querySelector(".enova-despacho-shipping-loading").classList.add("active")

        // hide shipping methods
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("active")
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("disabled")

    } else {
        document.querySelector(".enova-despacho-shipping-loading").classList.remove("active")

        // show shippingm methods
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("active")
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("disabled")
    }
}


function calculateShippingMethodToShowOption() {

    for(let methodOption of document.querySelectorAll("input[name=enova-despacho-tipo]")) {
        methodOption.addEventListener("change", (ev) => {
            console.log("label click")
            if( document.querySelector("input[name=enova-despacho-tipo]:checked") ) {
                document.querySelector(".enova-carrito-block-despacho-shipping__fecha").classList.remove("active")

                if( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "shipping-normal") {
                    // none
                } else if ( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "PROGRAMMED" ) {
                    console.log("label programado")

                    document.querySelector(".enova-carrito-block-despacho-shipping__fecha").classList.add("active")

                    // jQuery("#enova-despacho-delivery-select-fecha").val()
                    // jQuery("#enova-despacho-delivery-select-horario").val()
                    setLogistictProgrammedDateRules()

                } else if ( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "shipping-express" ) {
                    // none
                } else {
                    document.querySelector(".enova-carrito-block-despacho-shipping__fecha").classList.remove("active")
                }
            }

        })
    }
}

calculateShippingMethodToShowOption()


// shipping programmed logistic

function setLogistictProgrammedDateRules () {
    const inputFecha = document.getElementById('enova-despacho-delivery-select-fecha');
    const hoy = new Date();
    const horaActual = hoy.getHours();

    // Definir horario de corte
    const horarioCorte = 15; // 3 PM

    // Ajustar fecha de inicio al umbral de +1 día hábil
    const fechaInicio = new Date(hoy);
     if (horaActual >= horarioCorte) {
       // Si el horario de corte ya pasó, comenzar desde el siguiente día
       fechaInicio.setDate(fechaInicio.getDate() + 1);
     }

    let diasParaMin = 0; // Contador de días hábiles avanzados
    while (diasParaMin < 1) { // 1 dia
    
       fechaInicio.setDate(fechaInicio.getDate() + 1);
       if (fechaInicio.getDay() !== 0 && fechaInicio.getDay() !== 6) {
           diasParaMin++;
      }
    }

    // Calcular días hábiles y nombres
    const diasHabiles = [];
    const fechaTemporal = new Date(fechaInicio);

    const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

    while (diasHabiles.length < 7) {
      if (fechaTemporal.getDay() !== 0 && fechaTemporal.getDay() !== 6) { // filtrar domingo y sabado
      //if (fechaTemporal.getDay() !== 6) {
            const nombreDia = diasSemana[fechaTemporal.getDay()];
            const fechaISO = fechaTemporal.toISOString().split('T')[0];
            diasHabiles.push({ fecha: fechaISO, dia: nombreDia });
        }
        fechaTemporal.setDate(fechaTemporal.getDate() + 1);
    }

    // Crear opciones en el selector
    diasHabiles.forEach(({ fecha, dia }) => {
        const option = document.createElement('option');
        option.value = fecha;
        option.textContent = `${dia}, ${fecha}`;
        inputFecha.appendChild(option);
    });
}


// [] Formulario to Send Checkout

// crear campos metafields en el pedido V1
// enviar metadatos por API v1

// crear campos metafields en el pedido V2
// enviar metadatos por API v2

function checkoutButtonLoader(status) {
    if(status) {
        jQuery(".loader-button__text_container .loader-button__text").text("Cargando...")
        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "true")

        jQuery("#enova_cart-data-submit").css("pointer-events", 'none')
        jQuery("#enova_cart-data-submit").css("opacity", '.5')
    } else {
        jQuery(".loader-button__text_container .loader-button__text").text("Ir a Pagar")
        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "false")

        jQuery("#enova_cart-data-submit").css("pointer-events", 'initial')
        jQuery("#enova_cart-data-submit").css("opacity", '1')
    }
}




function setFakeButtonCart() {
    let templateButtonCart = `
        <div class="enova_terms_conditions_block">
            <label class="enova_terms_conditions_block_terms" for="terms_conditions" style="display: flex;flex-direction: row;align-content: inherit;align-items: baseline;">
                <input type="checkbox" id="terms_conditions"/>
                <p class="enova_terms_text" style="margin-left: 10px;">He leído y acepto los nuevos <a href="/policies/terms-of-service">Términos y Condiciones</a> de compra del sitio web.</p>
            </labe>
        </div>
        <div id="enova_cart-data-submit" is="loader-button" class="cart__checkout-button checkout-button button button--primary button--full">
            <span class="loader-button__text_container">
            <span class="loader-button__text">
                        <span class="checkout-button__lock"><svg focusable="false" width="17" height="17" class="icon icon--lock   " viewBox="0 0 17 17">
                <path d="M2.5 7V15H14.5V7H2.5Z" stroke="currentColor" stroke-width="1.5" fill="none"></path>
                <path d="M5.5 4C5.5 2.34315 6.84315 1 8.5 1V1C10.1569 1 11.5 2.34315 11.5 4V7H5.5V4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"></path>
                <circle cx="8.5" cy="11" r="0.5" stroke="currentColor"></circle>
            </svg></span>Ir a pagar</span>
            <span class="loader-button__loader" hidden="">
                <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
                </div>
            </span>
            </span>
            <span class="loader-button__loader" hidden="">
                <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
                </div>
            </span>
        </div>
    `

    if(
        document.querySelector(".cart__recap")
    ) {
        document.querySelector(".cart__recap").innerHTML += templateButtonCart
    } else {
        jQuery(".enova-carrito-block").after(templateButtonCart)
    }


    document.querySelector("#enova_cart-data-submit").addEventListener("click", (ev) => {
        ev.preventDefault()


        if( !jQuery("#terms_conditions").prop("checked") ) {
            console.log("Carrito checkout not found")

            // show message error
            document.querySelector("#enova-message-carrito").textContent = "Debes aceptar los términos y condiciones"
            document.querySelector("#enova-message-carrito").classList.add("active")

            return false
        }


        document.querySelector("#enova-message-carrito").classList.remove("active")
        document.querySelector("#enova-message-carrito").innerHTML = ""

        console.log("Carrito evento click")

        // document.querySelector("#enova_cart-data-submit")

        // reset obj_params

        function getDocumentValue(typeDocument) {
            let numberDocument = "" 

            if(typeDocument === "factura") {
                numberDocument = document.querySelector("#enova-billing-doc-ruc") ? document.querySelector("#enova-billing-doc-ruc").value : ""
            } else {
                numberDocument = document.querySelector("#enova-billing-documento-number") ? document.querySelector("#enova-billing-documento-number").value : ""
            }

            return numberDocument

        }

        // Carrito notes.attributes
        let type_document = document.querySelector("input[name=enova-billing-doc]:checked") ? document.querySelector("input[name=enova-billing-doc]:checked").value : '';

        function getShippingMatch() {
            //let shippingMethodSelected = document.querySelector("input[name=enova-despacho-tipo]:checked").value
            let addressSelected = document.querySelector("#enova-despacho-direccion").value

            // let formateAddress = document.querySelector("#enova-despacho-direccion") ? `${shippingMethodSelected}: ${addressSelected}` : ""
            let formateAddress = document.querySelector("#enova-despacho-direccion") ? addressSelected : ""
            return formateAddress
        }

        var obj_params = {
            attributes: {
                'pais': 'Peru',
                'Modalidad despacho': document.querySelector("input[name=enova-despacho]:checked") ? document.querySelector("input[name=enova-despacho]:checked").value : "",
                'departamento': document.querySelector("#enova-carrito-block-despacho-shipping__departamento  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__departamento  option:checked").textContent.trim() : "",
                'provincia': document.querySelector("#enova-carrito-block-despacho-shipping__provincia  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__provincia  option:checked").textContent.trim() : "",
                'distrito': document.querySelector("#enova-carrito-block-despacho-shipping__distrito  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__distrito  option:checked").textContent.trim() : "",
                'ubigeo': document.querySelector("#enova-carrito-block-despacho-shipping__distrito option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__distrito option:checked").dataset.code : "",
                'direccion': getShippingMatch(),
                'referencia': document.querySelector("#enova-despacho-referencia") ? document.querySelector("#enova-despacho-referencia").value : '',
                'comprobante de pago': type_document,
                'email': document.querySelector("#enova-billing-email") ? document.querySelector("#enova-billing-email").value : "", 
                'nombre': document.querySelector("#enova-billing-name") ? document.querySelector("#enova-billing-name").value : "",
                'apellido': document.querySelector("#enova-billing-lastName") ? document.querySelector("#enova-billing-lastName").value : "", 
                'telefono': document.querySelector("#enova-billing-telefono") ? document.querySelector("#enova-billing-telefono").value : "",
                'Documento Identidad': document.querySelector("#enova-billing-documento-number") ? document.querySelector("#enova-billing-documento-number").value : "",
                'tipo documento': document.querySelector("#enova-billing-documento-type") ? document.querySelector("#enova-billing-documento-type").value : ""
            }
        }

        if(document.querySelector("input[name=enova-despacho-tipo]:checked") && document.querySelector("input[name=enova-despacho-tipo]:checked").value === 'PROGRAMMED') {
            obj_params['attributes']['fecha de envio'] = document.querySelector("#enova-despacho-delivery-select-fecha").value;
            obj_params['attributes']['horario de recojo'] = document.querySelector("#enova-despacho-delivery-select-horario").value
        }


        if(document.querySelector("input[name=enova-billing-doc]:checked") && document.querySelector("input[name=enova-billing-doc]:checked").value === 'factura') {
            obj_params['attributes']['ruc'] = document.querySelector("#enova-billing-doc-ruc").value
            obj_params['attributes']['razon social'] = document.querySelector("#enova-billing-doc-razonsocial").value
        }



        if( document.querySelector("input[name=enova-despacho]:checked") 
        && document.querySelector("input[name=enova-despacho]:checked").value === "delivery" ) {
            obj_params = {
                attributes: {
                    ...obj_params.attributes,
                    'tipo de envio': document.querySelector("input[name=enova-despacho-tipo]:checked") ? document.querySelector("input[name=enova-despacho-tipo]:checked").value : '',
                }
            }
        }
        

        if( document.querySelector("input[name=enova-despacho]:checked") 
        && document.querySelector("input[name=enova-despacho]:checked").value === "recojo-tienda" ) {
            obj_params = {
                attributes: {
                    ...obj_params.attributes,
                    'departamento': document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.departamento : '',
                    'provincia': document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.provincia : '',
                    'distrito': document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.distrito : '',
                    'ubigeo': document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.ubigeo : '',
                    'direccion': document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") && jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? `Recojo Tienda: ${jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").parent().find(".enova-tienda-direccion").text()}` : "",
                    'referencia': '-',
                    'tienda recojo': jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").parent().find(".enova-tienda-titulo").text() : '',
                    // 'fecha de recojo': document.querySelector("#enova-despacho-recojo-tienda-select-fecha") ? document.querySelector("#enova-despacho-recojo-tienda-select-fecha").value : "",
                    // 'horario de recojo': document.querySelector("#enova-despacho-recojo-tienda-select-hora") ? document.querySelector("#enova-despacho-recojo-tienda-select-hora").value : "",
                }
            }

            if( obj_params && obj_params.attributes && obj_params.attributes['fecha de recojo'] && obj_params.attributes['horario de recojo'] ) {
                obj_params.attributes['referencia'] = `Fecha: ${obj_params.attributes['fecha de recojo']}, Horario: ${obj_params.attributes['horario de recojo']}`
            }
        }



        // validate billing address
        if(
            document.querySelector("input[name=enova-billing-doc]:checked") &&
            document.querySelector("input[name=enova-billing-doc]:checked").value === 'factura' &&
            !jQuery("#formulario--billing-address_checkbox").prop("checked") // no hay check, entonces si hay direccion de facturacion diferente
        ) {
            obj_params = {
                attributes: {
                    ...obj_params.attributes,
                    //'facturacion_departamento': document.querySelector("#enova-carrito-block-despacho-billing__departamento  option:checked") ? document.querySelector("#enova-carrito-block-despacho-billing__departamento  option:checked").textContent.trim() : "",
                    //'facturacion_provincia': document.querySelector("#enova-carrito-block-despacho-billing__provincia  option:checked") ? document.querySelector("#enova-carrito-block-despacho-billing__provincia  option:checked").textContent.trim() : "",
                    //'facturacion_distrito': document.querySelector("#enova-carrito-block-despacho-billing__distrito  option:checked") ? document.querySelector("#enova-carrito-block-despacho-billing__distrito  option:checked").textContent.trim() : "",
                    //'facturacion_ubigeo': document.querySelector("#enova-carrito-block-despacho-billing__distrito  option:checked") ? document.querySelector("#enova-carrito-block-despacho-billing__distrito  option:checked").dataset.code : "",
                    //'facturacion_direccion': document.querySelector("#enova-billing-direccion") ? document.querySelector("#enova-billing-direccion").value : '',
                    //'facturacion_referencia': document.querySelector("#enova-billing-referencia") ? document.querySelector("#enova-billing-referencia").value : ''
                }
            }
        }



        // validate all field not empty
        let formValid = true;
        for(let cartKey in obj_params.attributes) {
            if( obj_params.attributes[cartKey] === '' || obj_params.attributes[cartKey] === null || obj_params.attributes[cartKey] === undefined ) {
                console.log("key", obj_params.attributes[cartKey])
                formValid = false
            }
            if( document.querySelector("#enova-billing-telefono").value.length < 9 ) {
                formValid = false
            }
        }

        console.log("DATA", obj_params.attributes)

        /*
        * validate document type
        */
        function validateDocumentTypeForm() {
            var form_type_doc_selected = jQuery("#enova-billing-documento-type").val()
            let input_doc_number = jQuery("#enova-billing-documento-number").val()
            let input_doc_length = jQuery("#enova-billing-documento-number")[0].value.length;
            var form_message_doc_type = ""
            var form_doc_type = true

            if (form_type_doc_selected === "1") {
                // DNI
                if ( 
                    !( input_doc_length === 8  &&  Number(input_doc_number) > 0 )
                ) {
                    // error mesage
                    form_message_doc_type = "El campo Numero DNI debe tener 8 digitos"
                    form_doc_type = false
                    console.log("DNI FAIL")
                }

            } else if (form_type_doc_selected === "2") {
                // CE
                if ( 
                    !( input_doc_length >= 8 && input_doc_length <= 12  &&  /^[a-zA-Z0-9]+$/.test(input_doc_number) )
                ) {
                    // error mesage
                    form_message_doc_type = "El campo Numero Carnet Extranjeria debe tener 8-12 dígitos"
                    form_doc_type = false
                    console.log("CE FAIL")
                }

            } else if (form_type_doc_selected === "3") {
                // RUC
                if ( 
                    !( input_doc_length === 11  &&  Number(input_doc_number) > 0 )
                ) {
                    // error mesage
                    form_message_doc_type = "El campo Numero RUC debe tener 11 digitos"
                    form_doc_type = false
                    console.log("RUC FAIL")
                }
            }


            if (!form_doc_type) {
                // show message error
                // console.log("ERROR TIPO DOCUMENTO", form_message_doc_type)
                document.querySelector("#enova-message-carrito").textContent = form_message_doc_type
                document.querySelector("#enova-message-carrito").classList.add("active")

                // message border 
                document.querySelector("#enova-billing-documento-number").classList.add("input-has-error")

                // validation text
                if ( $(".text-has-error.text-typedoc").length == 0 ) {
                    $("#enova-billing-documento-number").parent().append(`<p class='text-has-error text-typedoc'>${form_message_doc_type}</p>`)
                } else {
                    $("p.text-has-error.text-typedoc").text(form_message_doc_type)
                }
              
            } else {
                // console.log("BIEN TIPO DOCUMENTO")
                document.querySelector("#enova-message-carrito").textContent = ""
                document.querySelector("#enova-message-carrito").classList.remove("active")

                document.querySelector("#enova-billing-documento-number").classList.remove("input-has-error")
                $("p.text-has-error.text-typedoc").remove()

            }

            return form_doc_type
        }

        var isTypeDocValid = validateDocumentTypeForm()

        if(!isTypeDocValid) {
            formValid = false
        }

      

        if(formValid) {
            console.log("El formulario correcto datos")

            document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "true")
            checkoutButtonLoader(true)

            fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },    
                body: JSON.stringify(obj_params)
            })
            .then(response => {
                return response.json();
            })
            .then(response => {
                console.log("CART response", response)
    
                document.querySelector("#enova-message-carrito").classList.remove("active")
                /*
                * CREATE CHECKOUT: DEFAULT
                */
                // document.querySelector(".cart__checkout-button").click()

                // GET CART
                // getResponseCartItems(true)
                //     .then((carritoItemsListE) => {
                //         console.log("CARRITO READY", carritoItemsListE)
                //         if( !isCarritoProductTypeShipping(carritoItemsListE) ) {
                //             // Digital Product
                //             // document.querySelector(".cart__checkout-button").click()
                //         } else {
                //             // Shipping
                //         }
                //     })


                /**
                * CREATE CHECKOUT: STOREFRONT CUSTOM
                */
                serviceCart2CheckoutStoreFrontAPI(obj_params)
                    .then((result) => {
                        console.log("result 1", result)

                        if(result && result.message && result.name === "Error") {
                            console.log("Result es tipo Error", result)
                            checkoutButtonLoader(false)
                            throw result
                        }
                        
                        if(result && result.checkout && result.checkout.webUrl) {
                            // set loader
                            checkoutButtonLoader(true)
                            
                            // redirect checkout
                            console.log("PROCESO TERMINADO CHECKOUT", result)

                            // building url checkout
                            let url_checkout_ = `${result.checkout.id}`
                            url_checkout_ = `https://gud.pe/cart/c/${url_checkout_.split("gid://shopify/Cart/")[1]}&channel=buy_button&_fd=0`
                            window.location.href = url_checkout_


                            // &step=contact_information
                            // ?step=shipping_method
                        } else {
                            // Error no se logro crear el checkout, redirect forzado retry zero
                            throw result
                        }
                    })
                    .catch((err) => {
                        console.log("err message final", err)

                        // unset loader
                        checkoutButtonLoader(false)

                        let message_output = ''
                        let isErrorForm_Retry = false

                        let jsonErrorObject = JSON.parse(err.message)

                        if(jsonErrorObject && jsonErrorObject[0] && jsonErrorObject[0].code === "INVALID" && jsonErrorObject[0].message) {
                            message_output = `Alguno de los campos no son validos: ${jsonErrorObject[0]['message']}`
                            isErrorForm_Retry = true
                        } else {
                            message_output= "No se pudo crear el pedido, algunos de los productos no estan disponible. Volver a intentar..."
                            isErrorForm_Retry = false
                        }

                        // unset loader
                        checkoutButtonLoader(false)

                        // show message error
                        document.querySelector("#enova-message-carrito").textContent = message_output
                        document.querySelector("#enova-message-carrito").classList.add("active")

                        // Fallo el pre-checkout, redirect to checkout normal

                        isErrorForm_Retry = true

                        if(!isErrorForm_Retry) {
                            fetch(window.Shopify.routes.root + 'cart.js', {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                              })
                              .then(response => {
                                return response.json();
                              })
                              .then(response => {
                                console.log("RESPONSE", response.token)
                                window.location.href = `https://gud.pe/checkouts/cn/${response.token}`
                              })
                              .catch((err) => {
                                console.log("Fallo segunda redireccion", err)
                                // show message error
                                document.querySelector("#enova-message-carrito").textContent = "No se pudo crear el pedido, algunos productos no estan disponibles, porfavor vuelve a intentar"
                                document.querySelector("#enova-message-carrito").classList.add("active")
                              })
                        }

                       
                        
                    })
    
            })
            .catch((error) => {
                console.error('CART Error:', error);
            });

  
        } else {
            console.log("El formulario falta datos")

            // Add class for error border
            if (obj_params.attributes.email === "") {
              document.querySelector("#enova-billing-email").classList.add("input-has-error")
            } else {
              document.querySelector("#enova-billing-email").classList.remove("input-has-error")
            }
            if (obj_params.attributes.nombre === "") {
              document.querySelector("#enova-billing-name").classList.add("input-has-error")
            } else {
              document.querySelector("#enova-billing-name").classList.remove("input-has-error")
            }
            if (obj_params.attributes.apellido === "") {
              document.querySelector("#enova-billing-lastName").classList.add("input-has-error")
            } else {
              document.querySelector("#enova-billing-lastName").classList.remove("input-has-error")
            }
            if (obj_params.attributes.telefono === "") {
              document.querySelector("#enova-billing-telefono").classList.add("input-has-error")
              if ( $(".text-has-error.text-phone").length == 0 ) {
                $("#enova-billing-telefono").parent().append("<p class='text-has-error text-phone'>El celular debe tener 9 dígitos</p>")
              }
            } else {
              if ( document.querySelector("#enova-billing-telefono").value.length < 9 ) {
                document.querySelector("#enova-billing-telefono").classList.add("input-has-error")
                if ( $(".text-has-error.text-phone").length == 0 ) {
                  $("#enova-billing-telefono").parent().append("<p class='text-has-error text-phone'>El celular debe tener 9 dígitos</p>")
                }
              } else {
                document.querySelector("#enova-billing-telefono").classList.remove("input-has-error")
                $("p.text-has-error.text-phone").remove();
              }
            }
            if (obj_params.attributes["Documento Identidad"] === "") {
              document.querySelector("#enova-billing-documento-number").classList.add("input-has-error")
            } else {
              document.querySelector("#enova-billing-documento-number").classList.remove("input-has-error")
              // validar type doc
              validateDocumentTypeForm()
            }
            if (obj_params.attributes["tipo de envio"] === "") {
                document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--title").classList.add("text-has-error")
              } else {
                document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--title").classList.remove("text-has-error")
              }

            if (obj_params.attributes["Modalidad despacho"] === "delivery") {
              if (obj_params.attributes.direccion === "") {
                document.querySelector("#enova-despacho-direccion").classList.add("input-has-error")
              } else {
                document.querySelector("#enova-despacho-direccion").classList.remove("input-has-error")
              }
              if (obj_params.attributes.referencia === "") {
                document.querySelector("#enova-despacho-referencia").classList.add("input-has-error")
              } else {
                document.querySelector("#enova-despacho-referencia").classList.remove("input-has-error")
              }
              if (obj_params.attributes.departamento === "Seleccione...") {
                document.querySelector("#enova-carrito-block-despacho-shipping__departamento").classList.add("input-has-error")
              } else {
                document.querySelector("#enova-carrito-block-despacho-shipping__departamento").classList.remove("input-has-error")
              }
              if (obj_params.attributes.provincia === "Seleccione") {
                document.querySelector("#enova-carrito-block-despacho-shipping__provincia").classList.add("input-has-error")
              } else {
                document.querySelector("#enova-carrito-block-despacho-shipping__provincia").classList.remove("input-has-error")
              }
              if (obj_params.attributes.distrito === "Seleccione") {
                document.querySelector("#enova-carrito-block-despacho-shipping__distrito").classList.add("input-has-error")
              } else {
                document.querySelector("#enova-carrito-block-despacho-shipping__distrito").classList.remove("input-has-error")
              }
             
            }

            // validacion error despacho selected
            if( document.querySelector("input[name=enova-despacho]:checked") ) {
                // clean error
                document.querySelector("#enova-despacho-delivery-option").parentNode.parentNode.parentNode.classList.remove("input-has-error")
                jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option").hide()

            } else {
                // error
                document.querySelector("#enova-despacho-delivery-option").parentNode.parentNode.parentNode.classList.add("input-has-error")

                if(
                    jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option") &&
                    jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option")[0]
                ) {
                    // show
                    jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option").show()
                    
                } else {
                    // create
                    jQuery("#enova-despacho-delivery-option").parent().parent().parent().append(`<div class="msg-error-not-selected-option">Debes seleccionar tu tipo de Despacho</div>`)

                }
            }

            // validacion error billing selected
            if( document.querySelector("input[name=enova-billing-doc]:checked") ) {
                document.querySelector("#enova-despacho-billing-boleta").parentNode.parentNode.parentNode.classList.remove("input-has-error")
                jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option").hide()

            } else {
                document.querySelector("#enova-despacho-billing-boleta").parentNode.parentNode.parentNode.classList.add("input-has-error")

                if(
                    jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option") &&
                    jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option")[0]
                ) {
                    // show
                    jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option").show()
                    
                } else {
                    // create
                    jQuery("#enova-despacho-billing-boleta").parent().parent().parent().append(`<div class="msg-error-not-selected-option">Debes seleccionar tu tipo de comprobante</div>`)

                }
            }


            // validacion error billing selected
            if( document.querySelector("input[name=enova-despacho-tipo]:checked") ) {
                document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--list").parentNode.parentNode.parentNode.classList.remove("input-has-error")
                jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option").hide()

            } else {
                document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--list").parentNode.parentNode.parentNode.classList.add("input-has-error")

                if(
                    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option") &&
                    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option")[0]
                ) {
                    // show
                    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option").show()
                    
                } else {
                    // create
                    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").append(`<div class="msg-error-not-selected-option">Debes seleccionar metodo de envio.</div>`)

                }
            }



            // enova-carrito-block-despacho-shipping-tipo__delivery--list

            // END Add class for error border

            document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "false")

            document.querySelector("#enova-message-carrito").textContent = "Debes completar las casillas faltantes en rojo"
            document.querySelector("#enova-message-carrito").classList.add("active")
          
        }

    })

    // check terms y condiciones
    let templateTermsCondicions = `
        <div class="enova_terms_conditions_block">
            <input type="checkbox" id="terms_conditions"/>
            <p>He leído y acepto los nuevos <a href="/policies/terms-of-service">Términos y Condiciones</a> de compra del sitio web.</p>
        </div>
    `

    if(
        !(
        jQuery(".enova_terms_conditions_block") &&
        jQuery(".enova_terms_conditions_block")[0] 
        ) &&
        false
    ) {
        document.querySelector(".cart__recap").innerHTML += templateTermsCondicions
    }

}

var setCheckerCartDiscountLabel = setInterval(() => {
    if (window.location.href.includes("cart") && 
    // document.querySelector(".cart__recap") && 
    !(document.querySelector("#enova_cart-data-submit")) ) {
        setFakeButtonCart()

        // GET CART
        getResponseCartItems(true)
            .then((carritoItemsListE) => {
                console.log("CARRITO READY", carritoItemsListE)
                if( !isCarritoProductTypeShipping(carritoItemsListE) ) {
                    // is Digital/Service Products
                    // jQuery(".enova-carrito-block").removeClass("active")
                    // jQuery("#enova_cart-data-submit").hide()
                    // jQuery("button.cart__checkout-button:first").show()

                    // show buttons
                    jQuery(".enova-carrito-block").addClass("active")
                    jQuery("#enova_cart-data-submit").show()

                    // hide options
                    jQuery(".enova-carrito-block-seleccion-despacho").hide()

                    jQuery("#despacho-title").hide()
                    jQuery(".enova-carrito-block-despacho-shipping__title").text("Ingrese su dirección de facturación")

                    // auto select Shipping opcion
                    jQuery(".enova-carrito-block-seleccion-despacho__container #enova-despacho-delivery-option").parent().click()

                    // remove shipping active default option
                    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery").removeClass("active")

                } else {
                    // is Shipping Products
                    jQuery(".enova-carrito-block").addClass("active")
                    jQuery("#enova_cart-data-submit").show()
                }
            })

        // set form data
        initSetFormDataUbigeosAvailable()

    }
}, 1000)

 // Validate CART has digital product
 function isCarritoProductTypeShipping(cartList) {
    let isCarritoReadyForShipping = false;
    
    for(let product of cartList) {
        let isShipping = product.requires_shipping
        if(isShipping) {
            // grams "0" = Producto digital
            // grams "0 >" = Producto fisico
            isCarritoReadyForShipping = true
            break;
        }
    }

    if(cartList && cartList.length === 0) {
        isCarritoReadyForShipping = true
    }

    return isCarritoReadyForShipping
}

async function serviceCart2CheckoutStoreFrontAPI(cartAttributes) {
    try {
        async function createCheckout(client, inputCheckout) {

            let inputData = {
                email: inputCheckout.email,
                lineItems: inputCheckout.lineItems,
                shippingAddress: inputCheckout.shippingAddress,
                customAttributes: inputCheckout.customAttributes,
            }

            // Create an empty checkout
            let checkoutResponse = await client.checkout.create(inputData).then((checkout) => {
                // Do something with the checkout
                return checkout
            });
    
            return checkoutResponse
        }
    
        async function checkoutAddItems(client, checkoutId, lineItemsToAdd) {
            // UPDATE CHECKOUT - Add an item to the checkout
            let responseItems = await client.checkout.addLineItems(checkoutId, lineItemsToAdd)
            .then((checkout) => {
                console.log("checkoutA", checkout);
                return checkout
            })
            .catch((err) => {
                console.log("error", err)
            })
    
            return responseItems
        }
    
        async function checkoutAddAttributes(client, checkoutId, input) {
            let responseAttributes = await client.checkout.updateAttributes(checkoutId, input)
            .then((checkout) => {
                // Do something with the updated checkout
    
                return checkout
            });
    
            return responseAttributes
        }
    
        
        function getCartAttributesFormatted(cartAttributes) {
            // UPDATE CHECKOUT - checkout attributes
            let checkoutattrs = []
            for(let cartKey in cartAttributes.attributes) {
                let objectAttributes = {
                    key: cartKey,
                    value: cartAttributes.attributes[cartKey]
                }
                checkoutattrs.push(objectAttributes)
            }
        
            // let cartAtributesList = {
            //     customAttributes: checkoutattrs
            // };
            let cartAtributesList = checkoutattrs
            return cartAtributesList
        }
    
        async function getCheckoutById(checkoutId) {
            // Fetching a Checkout
            let checkoutPaylaod =  client.checkout.fetch(checkoutId).then((checkout) => {
                return checkout
            });
    
            return checkoutPaylaod
        }
    
    
        function checkoutUpdateAddress(shippingAddress) {
            function getProvinceCorrelatives (province) {
                switch(province) {
                    case "Lima":
                    case "LIMA":
                        return "PE-LIM";
                    default:
                        return province
                }
            }
    
            console.log("shippingAddress", shippingAddress)
    
    
            // Updating a Shipping Address
            const shippingAddressObj = {
                address1: shippingAddress['direccion'], //ok
                address2: shippingAddress['referencia'], // ok
                firstName: shippingAddress['nombre'], // ok
                lastName: shippingAddress['apellido'], // ok
                company:  shippingAddress['comprobante de pago'] === "factura" ? shippingAddress['ruc'] : shippingAddress['Documento Identidad'], // ok   shippingAddress['Documento Identidad']
                phone: shippingAddress['telefono'], // ok
                country: shippingAddress['pais'], // ok
                province: getProvinceCorrelatives(shippingAddress['departamento']),
                city: shippingAddress['provincia'],
                // zip: `${shippingAddress['distrito']}#${shippingAddress['ubigeo']}`
                zip: shippingAddress['distrito']
            };

            console.log("shippingAddressObj", shippingAddressObj)

            return shippingAddressObj
        }

        async function checkoutUpdateAddressSendAPI(client, checkoutId, shippingAddressObj) {
            console.log("shippingAddressObj", shippingAddressObj)

            // Update the shipping address for an existing checkout.
            let checkoutAddressResponse = await client.checkout.updateShippingAddress(checkoutId, shippingAddressObj).then(checkout => {
                // Do something with the updated checkout
                console.log("CHECKOUT UPDATED2", checkout)
                return checkout
            });
    
            return checkoutAddressResponse
        }
    
        async function checkoutUpdateEmail(client, checkoutId, email) {
            let checkoutEmailResponse = await client.checkout.updateEmail(checkoutId, email).then((checkout) => {
                console.log("Email updated", checkout)
                return checkout
            });
    
            return checkoutEmailResponse
        }
    
        // Initializing a client to return content in the store's primary language
        let client = ShopifyBuy.buildClient({
            domain: 'gud-tienda-peru.myshopify.com',
            storefrontAccessToken: 'ced042048ac2652fe3ff3aca071cde59'
            // domain: 'enova-test-dev.myshopify.com',
            // storefrontAccessToken: '297178dbebb0dcdc52d0ec1c882b9807'
        });
        
    
        // GET CART
        let carritoItemsList = await getResponseCartItems()

        console.log("carritoItemsList", carritoItemsList)
        let checkoutAtributesList = getCartAttributesFormatted(cartAttributes)
        let checkoutAddressParsed2Checkout = checkoutUpdateAddress(cartAttributes.attributes)

        let inoutCheckout2Create = {
            email: cartAttributes.attributes.email,
            lineItems: carritoItemsList,
            shippingAddress: checkoutAddressParsed2Checkout,
            customAttributes: checkoutAtributesList
        }

        console.log("checkout create", inoutCheckout2Create)

        // CREATE CHECKOUT - create checkout base
        let checkout = await createCheckout(client, inoutCheckout2Create)
    
        // const checkoutId = checkout.id
        // let checkoutPayloadResponse = await getCheckoutById(checkoutId)

        if(!(checkout && checkout.id && checkout.email && checkout.shippingAddress)) {
            throw "error create checkout"
        } else {
            console.log("CHECKOUT", checkout)
            return ({checkout: checkout })
        }
        
        // const checkoutId = checkout.id
        // let lineItemsToAdd = carritoItemsList
        // let checkoutAddLineItems = await checkoutAddItems(client, checkoutId, lineItemsToAdd)
        
        // console.log("checkoutAddLineItems", checkoutAddLineItems.lineItems)
        // if (!(checkoutAddLineItems.lineItems && checkoutAddLineItems.lineItems.length)) {
        //     throw "err1"
        // }
    
        // let checkoutAtributesList = getCartAttributesFormatted(cartAttributes)
        // let checkoutResponseAttributes = await checkoutAddAttributes(client, checkoutId, checkoutAtributesList)
        // let checkoutPayloadResponse = await getCheckoutById(checkoutId)
    
        // if(!(checkoutResponseAttributes && checkoutPayloadResponse && checkoutPayloadResponse.id)) {
        //     throw "err2"
        // }
    
        // let checkoutAddressParsed2Checkout = checkoutUpdateAddress(cartAttributes.attributes)
        // let checkoutAddressUpdated = await checkoutUpdateAddressSendAPI(client, checkoutId, checkoutAddressParsed2Checkout)
        // console.log("CHECKOUT FINISHED?", checkoutAddressUpdated)
    
        // let email = cartAttributes.attributes.email
        // let checkoutEmail = await checkoutUpdateEmail(client, checkoutId, email)
        
        
        // if(checkoutAddressUpdated && checkoutAddressUpdated && checkoutAddressUpdated.shippingAddress && checkoutEmail) {
        //     return ({checkout: checkoutAddressUpdated })
        // } else {
        //     throw "err3"
        // }

    } catch(err) {
        console.log("error", err)

        // unset loader
        checkoutButtonLoader(false)

        // show message error
        document.querySelector("#enova-message-carrito").textContent = "No se pudo crear el pedido, algunos de los productos no estan disponible. Porfavor volver a intentar en unos minutos!"
        document.querySelector("#enova-message-carrito").classList.add("active")

        return err
    }
}


async function getResponseCartItems(format = null) {
    let carritoItems = []

    const responseCart = await fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET'
    })

    const dataCart = await responseCart.json();
    for(let item of dataCart.items) {

        let varianIdEncoded64 = `gid://shopify/ProductVariant/${item.variant_id}`
        function utf8_to_b64(str) {
            return window.btoa(unescape(encodeURIComponent(str)));
        }
            
        let getUbigeoSelected = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo")
        let getShippingMethod = jQuery("input[name=enova-despacho-tipo]:checked").val()
        let getDespacho = jQuery("input[name=enova-despacho]:checked").val()

        let lineItemsToAdd = {
            variantId: utf8_to_b64(varianIdEncoded64),
            quantity: item.quantity,
            attributes: [
                {key: "tipo de despacho", value: getDespacho},
                {key: "shipping method", value: getShippingMethod},
                {key: "ubigeo", value: String(getUbigeoSelected) },
                {key: "peso", value: String(item.grams) },
                {key: "sku", value: String(item.sku) }
            ]
            // customAttributes: [
            //     {key: "tipo de despacho", value: getDespacho},
            //     {key: "shipping method", value: getShippingMethod},
            //     {key: "ubigeo", value: String(getUbigeoSelected) },
            //     {key: "peso", value: String(item.grams) },
            //     {key: "sku", value: String(item.sku) }
            // ]
        }

        if(format) {
            let isShipping = item.grams && item.grams > 0 ? true : false
            lineItemsToAdd['requires_shipping'] = isShipping    
            lineItemsToAdd['requires_shipping'] = true // FORCE ALL FISICAL ITEMS  - SHIPPING
        }

        carritoItems.push(lineItemsToAdd)

    }

    return carritoItems
} 


async function populate(scope = "departaments", options) {
    try {
         // 
        let countrySelected = options.country
        let departamentoSelected = options.departament
        let provinceSelected = options.district

        let urlBuilder = null

        if(scope === "departaments") {
            urlBuilder = `?scope=departaments&country=${countrySelected}`
            
        } else if (scope === "provinces") {
            urlBuilder = `?scope=provinces&country=${countrySelected}&departament=${departamentoSelected}`
            
        } else if (scope === "distrits") {
            urlBuilder = `?scope=distrits&country=${countrySelected}&departament=${departamentoSelected}&province=${provinceSelected}`
        }
         

        //  recojo en tienda
        let departamentos = await fetch(`${window.Shopify.routes.root}apps/apolo-ubigeo-calculation${ urlBuilder }`, {
            "method": "GET",
            "headers": {
                'Content-Type': 'application/json'
            }
        })
        .then((res) => res.json())
        .then((response) => {
            let filteredResponse = response.filter((item) => {
                if("is_active" in item) {
                    return item.is_active
                } else {
                    return item
                }
            })

            return filteredResponse
        })
        .then((response) => {
            console.log("response", response)
            return response
        })
        .catch(error => console.error('Error:', error))

        console.log("UBIGEOS - ", scope, departamentos)
 
        return departamentos
 
    } catch(err) {
         console.log("err", err)
         return err
    }
 
}
 
async function getPickUpShopList(filter_zona = null) {

    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html("")
    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html("<p>Validando</p>")

    //  recojo en tienda
    let shopsList = await fetch(`${window.Shopify.routes.root}apps/apolo-ubigeo-calculation?scope=shop-addresses`, {
        "method": "GET",
        "headers": {
            'Content-Type': 'application/json'
        }
    })
    .then((res) => res.json())
    .then((response) => {
        return response.items
    })
    .catch(error => console.error('Error:', error))

    console.log("lista de tiendas", shopsList)

    // FILTRO STORE LIST
    let list_stores_filtered = []

    if(filter_zona) {
        list_stores_filtered = shopsList.filter((element) => {
            return element['department'] === filter_zona
        })

        // replace
        shopsList = list_stores_filtered;
    }

    // render on list
    // shopsList
    let templateBlockStoreList = ""

    for(let store of shopsList) {
        let templateItemElement = `
            <label class="enova-carrito-block-despacho-recojo-tienda__list-tiendas--item" for="enova-despacho-recojo-tienda-item-${store.id}">
                <input type="radio" name="enova-despacho-recojo-tienda-item" id="enova-despacho-recojo-tienda-item-${store.id}" data-departamento="${store.department}" data-provincia="${store.province}" data-distrito="${store.distrit_name}" data-ubigeo="${store.ubigeo}" />
                <div class="enova-carrito-block-despacho-recojo-tienda__list-tiendas--item__text">
                    <h3 class="enova-tienda-titulo">${store.name}</h3>
                    <p class="enova-tienda-direccion">${store.address}</p>
                </div>
            </label>
        `
        templateBlockStoreList += templateItemElement
    }

    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html(templateBlockStoreList)

    setTimeout(() => {
        setStoresEventClick()
    }, 300)

    return shopsList
}


function setStoreListFilter() {
    jQuery("#enova-carrito-block-despacho-recojo__filtro").on("change", (ev) => {
        console.log("event select changed", ev.target.value)
        let filter_store_selected = ev.target.value

        getPickUpShopList(filter_store_selected)
    })
}

setStoreListFilter()

function setResetSelectorOptions(scope, addressBilling = null) {
    let templateList = `<option value="">Seleccione</option>`
    if(scope === "departaments") {

        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__departamento").html(templateList)
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__departamento").html(templateList)
        }
    } else if(scope === "provinces") {

        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__provincia").html(templateList)
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__provincia").html(templateList)
        }

    } else if (scope === "distrits") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__distrito").html(templateList)
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__distrito").html(templateList)
        }
    }
}


function setSelectorOptions(scope, optionList, addressBilling = null) {
    if(scope === "departaments") {
        let templateList = '<option>Seleccione...</option>'
        for(let optionUbigeo of optionList) {
            let itemOptionTemplate = `
                <option value="${optionUbigeo.name}" data-ubigeo="${optionUbigeo.code}" data-code="${optionUbigeo.code}" data-id="${optionUbigeo.id}">${optionUbigeo.name}</option>
            `
            templateList += itemOptionTemplate;
        }
        
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__departamento").html(templateList)
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__departamento").html(templateList)
        }

        
    } else if(scope === "provinces") {

        let templateList = '<option>Seleccione...</option>'
        for(let optionUbigeo of optionList) {
            let itemOptionTemplate  = `
                <option value="${optionUbigeo.name}" data-ubigeo="${optionUbigeo.code}" data-code="${optionUbigeo.code}" data-id="${optionUbigeo.id}">${optionUbigeo.name}</option>
            `
            templateList += itemOptionTemplate;
        }

        
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__provincia").html(templateList)
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__provincia").html(templateList)
        }
        

    } else if (scope === "distrits") {

        let templateList = '<option>Seleccione...</option>'
        for(let optionUbigeo of optionList) {
            let itemOptionTemplate  = `
                <option value="${optionUbigeo.name}" data-ubigeo="${optionUbigeo.code}" data-code="${optionUbigeo.code}" data-id="${optionUbigeo.id}">${optionUbigeo.name}</option>
            `
            templateList += itemOptionTemplate;
        }
        
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__distrito").html(templateList)
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__distrito").html(templateList)
        }

    }

}


function initSetFormDataUbigeosAvailable() {

    setResetSelectorOptions('departaments')
    setResetSelectorOptions('provinces')
    setResetSelectorOptions('distrits')

    setResetSelectorOptions('departaments', true)
    setResetSelectorOptions('provinces', true)
    setResetSelectorOptions('distrits', true)


    // Init data deparments
    populate("departaments", {
        country: "1", // peru
        departament: null,
        district: null
    })
    .then((result) => {
        let departmentsList = result 
        setSelectorOptions("departaments", departmentsList)
        setSelectorOptions("departaments", departmentsList, true)
    })
    .catch((err) => {
        console.log("err ubigeo selector departaments", err)
    })




    /*
    * shipping address
    */

    // event departaments 
    jQuery("#enova-carrito-block-despacho-shipping__departamento").on("change", () => {

        setResetSelectorOptions('provinces')
        setResetSelectorOptions('distrits')


        // Get Provinces
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-shipping__departamento option:selected").data("id") 
        let SelectedDepartamentoUBIGEO = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo") 

        populate("provinces", {
            country: "1", // Peru
            departament: SelectedDepartamentoID,
            district: null
        })
        .then((result) => {
            let provincesList = result 
            setSelectorOptions("provinces", provincesList)
        })
        .catch((err) => {
            console.log("err ubigeo selector provinces", err)
        })

    })


    // event provincia 
    jQuery("#enova-carrito-block-despacho-shipping__provincia").on("change", () => {
        setResetSelectorOptions('distrits')
        
        // Get distritos
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-shipping__departamento option:selected").data("id") 
        let SelectedProvinciaID = jQuery("#enova-carrito-block-despacho-shipping__provincia option:selected").data("id") 
        
        populate("distrits", {
            country: "1",
            departament: SelectedDepartamentoID,
            district: SelectedProvinciaID
        })
        .then((result) => {
            let districtList = result 
            setSelectorOptions("distrits", districtList)
        })
        .catch((err) => {
            console.log("err ubigeo selector distrits", err)
        })

    })


    // event distrito 
    jQuery("#enova-carrito-block-despacho-shipping__distrito").on("change", () => {
        // On change get shipping rates

        // CALL UBIGEO CALCULATOR
    })



    /*
    * billing address
    */
    // event departaments 
    jQuery("#enova-carrito-block-despacho-billing__departamento").on("change", () => {

        setResetSelectorOptions('provinces', true)
        setResetSelectorOptions('distrits', true)


        // Get Provinces
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-billing__departamento option:selected").data("id") 
        let SelectedDepartamentoUBIGEO = jQuery("#enova-carrito-block-despacho-billing__distrito option:selected").data("ubigeo") 

        populate("provinces", {
            country: "1", // Peru
            departament: SelectedDepartamentoID,
            district: null
        })
        .then((result) => {
            let provincesList = result 
            setSelectorOptions("provinces", provincesList, true)
        })
        .catch((err) => {
            console.log("err ubigeo selector provinces", err)
        })

    })


    // event provincia 
    jQuery("#enova-carrito-block-despacho-billing__provincia").on("change", () => {
        setResetSelectorOptions('distrits', true)
        
        // Get distritos
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-billing__departamento option:selected").data("id") 
        let SelectedProvinciaID = jQuery("#enova-carrito-block-despacho-billing__provincia option:selected").data("id") 
        
        populate("distrits", {
            country: "1",
            departament: SelectedDepartamentoID,
            district: SelectedProvinciaID
        })
        .then((result) => {
            let districtList = result 
            setSelectorOptions("distrits", districtList, true)
        })
        .catch((err) => {
            console.log("err ubigeo selector distrits", err)
        })

    })


    // event distrito 
    jQuery("#enova-carrito-block-despacho-billing__distrito").on("change", () => {
        // On change get shipping rates

        // CALL UBIGEO CALCULATOR
    })
    





    // event facturacion address
    jQuery("#formulario--billing-address_checkbox").on("change", (ev) => {
        console.log("event changed", jQuery(ev.currentTarget))
        
        if(
            !jQuery("#formulario--billing-address_checkbox").prop("checked")
        ) {
            jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "block")
        } else {
            jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "none")
        }
    })

}


function SetRenderShippingMethodsListOption(methodsList) {
    let templateList = ''

    for(let method of methodsList) {
        let templateItem = `
            <div class="enova-carrito-block-despacho-shipping-tipo__delivery--method">
                <input type="radio" name="enova-despacho-tipo" class="enova-delivery-method-1" id="enova-delivery-method-${method.code}" value="${method.code}">
                <label for="enova-delivery-method-${method.code}" class="enova-shipping-tipo__delivery-label enova-shipping-tipo__delivery--method1">
                    <div class="enova-shipping-method-tag-name-title">
                        <span class="enova-shipping-method-title">${method.name} </span>
                        <span class="enova-shipping-method-separator"> -- </span>
                        <span class="enova-shipping-method-cost">
                            ${method.is_free_shipping ? 'Gratis' : `S/ ${method.price}`}
                        </span>
                    </div>
                    <div class="enova-shipping-method-tag-description">
                        <p>${method.description}</p>
                    </div>
                </label>
            </div>
        `

        templateList += templateItem
    }
    
    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").html(templateList)

    calculateShippingMethodToShowOption()
}


function setRenderCartFormKeypressValidation() {
    jQuery('.page-content form').on('keyup keypress', function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) { 
          e.preventDefault();
          return false;
        }
    });

     // select document type
    jQuery("#enova-billing-documento-type").on("change", (ev) => {
        jQuery("#enova-billing-documento-number").val("")
        $("p.text-has-error.text-typedoc").remove()
        document.querySelector("#enova-billing-documento-number").classList.remove("input-has-error")
      
    })

     // documento tpye
    jQuery("#enova-billing-documento-number").on("keypress", (ev) => {
        // Input doc type
        let input_doc_type_selected = jQuery("#enova-billing-documento-type").val()
        let currentLength = ev.currentTarget.value.length;

        if(input_doc_type_selected === "1") {
            // DNI
            regex = /^[0-9]$/; // Solo dígitos
            if (currentLength >= 8) {
                ev.preventDefault(); // Evita más entradas
            }

        } else if(input_doc_type_selected === "2") {
            // CE
            regex = /^[a-zA-Z0-9]$/; // Alfanumérico
            if (currentLength >= 12) {
                ev.preventDefault(); // Evita más entradas
            }

        } else if(input_doc_type_selected === "3") {
            // RUC
            regex = /^[0-9]$/; // Solo dígitos
            if (currentLength >= 11) {
                ev.preventDefault(); // Evita más entradas
            }
        } else {
            return; // Si no hay opción seleccionada, no hacer nada
        }

        // Validar la tecla presionada
        if (!regex.test(ev.key)) {
            ev.preventDefault(); // Evita la entrada de caracteres no válidos
        }
    })

    // telefono
    jQuery("#enova-billing-telefono").on("keypress", (ev) => {
        if (!/[0-9]/.test(ev.key)) {
            ev.preventDefault();
        }
    })

    // ruc
    jQuery("#enova-billing-doc-ruc").on("keypress", (ev) => {
        if (!/[0-9]/.test(ev.key)) {
            ev.preventDefault();
        }
    })

    // Update fields text
    $("[for='enova-billing-telefono']").text("Celular");

}

setRenderCartFormKeypressValidation()



/*
* Cart step 1
*/
function cartStep1() {
    let buttonCartCheckoutStep = document.querySelector(".enova_cart_button_step1")

    buttonCartCheckoutStep.addEventListener("click", (ev) => {
        console.log("eveneto click")

        let blockCartStep = document.querySelector(".enova-block-carrito-main")
        let blockCart = document.querySelector("#MinimogCart form")

        let blockCartTittle = document.querySelector(".m-page-header__title")
        let blockCartBreadCrum = document.querySelector(".m-page-header--template-cart .m-breadcrumb--wrapper")

        // set auto click - reset "delivery"
        document.querySelector("input[name=enova-despacho]:first-child").click()

        if( blockCartStep.classList.contains("active") ) {
            // It's open - it's already open
            //blockCartStep.classList.remove("active")

            // show cart list
            blockCart.classList.remove("closed")

        } else {
            // It's closed - first visit before checkout
            blockCartStep.classList.add("active")

            // close cart list
            blockCart.classList.add("closed")

            blockCartTittle.classList.add("closed")
            blockCartBreadCrum.classList.add("closed")
        }

    })
}

cartStep1()

// function requestCartList() {
//     return new Promise((resolve, reject) => {
//         resolve('resolved');
//     });
// }

// // GET CARRITO
// let carritoItems = []


// fetch(window.Shopify.routes.root + 'cart.js', {
//     method: 'GET'
//   })
//   .then(response => {
//     return response.json();
//   })
//   .then(response => {

//     for(let item of response.items) {

//         let varianIdEncoded64 = `gid://shopify/ProductVariant/${item.variant_id}`
//         let lineItemsToAdd = {
//             variantId: varianIdEncoded64,
//             quantity: item.quantity,
//             // customAttributes: [{key: "MyKey", value: "MyValue"}]
//         }

//         carritoItems.push(lineItemsToAdd)

//     }
    

//     console.log("CART response", response)
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   });


// UPDATE CARRITO
// endpoint to update the cart's line item quantities, note, or attributes.

// var obj_params = {
//     note: 'This is a note about my order'
// }

// fetch(window.Shopify.routes.root + 'cart/update.js', {
//     method: 'POST',
//     headers: {
//         'Content-Type': 'application/json'
//     },    
//     body: JSON.stringify(obj_params)
    
//   })
//   .then(response => {
//     return response.json();
//   })
//   .then(response => {
//     console.log("CART response", response)
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   });


//   fetch(window.Shopify.routes.root + 'cart/update.js?attributes[departamento]=Yes', {
// 

